import React from "react";
import { Leaf, ArrowRight } from "lucide-react";

const Hero = ({ scrollTo }) => (
  <section
    id="home"
    className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16"
  >
    <div className="absolute inset-0 z-0">
      <img
        alt="Dehydrated organic powders and spices background"
        className="w-full h-full object-cover"
        /* Replaced strawberry image with premium dehydrated powders/spices */
        src="https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=1200"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-primary/95 via-primary/85 to-primary/50"></div>
    </div>

    <div className="relative z-10 container mx-auto px-4 text-center text-white py-12 md:py-20">
      <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 md:px-5 py-2 rounded-full mb-6 border border-white/20">
        <Leaf className="h-4 w-4 md:h-5 md:w-5 text-accent" />
        <span className="text-[10px] md:text-sm font-semibold tracking-wide uppercase text-white">
          100% Organic & Natural
        </span>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold leading-[1.2] md:leading-[1.1] mb-6 tracking-tight uppercase">
        Dehydrated Organic Powders
        <br className="hidden sm:block" />
        <span className="text-accent text-xl sm:text-3xl md:text-4xl block mt-2">
          & Quality Groceries
        </span>
      </h1>

      <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto mb-10 font-light px-4">
        IndoGlobus - Your trusted partner for premium organic products from
        Hyderabad, India to the world.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-6">
        <button
          onClick={() => scrollTo("about")}
          className="w-full sm:w-auto bg-accent text-primary hover:bg-white px-8 py-4 rounded-xl font-bold text-base md:text-lg shadow-lg transition-all hover:scale-105 flex items-center justify-center gap-2"
        >
          Explore Now <ArrowRight size={20} />
        </button>
        <button
          onClick={() => scrollTo("contact")}
          className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-xl font-bold text-base md:text-lg backdrop-blur-sm transition-all"
        >
          Connect With Us
        </button>
      </div>
    </div>
  </section>
);

export default Hero;
